<template>
  <div class="institutionModal">
    <el-dialog
        :title="title"
        :visible.sync="visible"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        width="30%"
        :center="true"
        @open="handleOpen"
    >
      <div v-if="isView" class="warn">
        您的账号存在于多机构中，请选择您要进入的机构
      </div>
      <div>
        <el-radio-group v-model="value" @input="handleChange">
          <el-radio
              v-for="item in tenantsList"
              :key="item.id"
              v-model="item.id"
              :label="item.id"
          >{{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
            v-if="!isView"
            plain
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleClose"
        >取消
        </el-button>
        <el-button
            size="small"
            style="width: 30%; display: inline-block"
            type="primary"
            @click="handleConfirm"
        >提交
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: "institutionModal",
  props: {
    isView: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value: "",
      title: "提示",
    };
  },
  watch: {
    isView: {
      handler(newValue) {
        if (!newValue) {
          this.title = "切换企业 | 机构";
        }
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    ...mapState("user", ["institutionModalVisible"]),
    ...mapState("tenant", ["tenantsList"]),
    visible: {
      get() {
        return this.$store.state.user.institutionModalVisible;
      },
      set(value) {
        this.$store.commit("user/setData", {
          key: "institutionModalVisible",
          value,
        });
      },
    },
  },
  methods: {
    ...mapMutations("user", ["setData"]),
    ...mapActions("user", ["login", "getUserInfo"]),
    handleClose() {
      this.setData({key: "institutionModalVisible", value: false});
    },
    handleOpen() {
      if (this.isView) {
        this.value = this.tenantsList[0].id;
      } else {
        this.value = JSON.parse(localStorage.getItem("tenantId"));
      }
    },
    handleChange(val) {
    },
    async handleConfirm() {
      localStorage.setItem("tenantId", this.value);
      this.setData({key: "institutionModalVisible", value: false});
      await this.getUserInfo();
      await this.$router.go(0);
    },
  },
};
</script>

<style lang="scss" scoped>
.institutionModal {
  ::v-deep .el-dialog {
    min-width: 420px;
  }

  .warn {
    color: red;
    background: #f2f2f2;
    text-align: center;
    padding: 10px 0;
    margin-bottom: 20px;
  }

  ::v-deep .el-radio {
    display: block;
    line-height: 23px;
    white-space: normal;
    margin-right: 0;
  }
}
</style>
